import Vue from 'vue';
import App from './App.vue';
import router from './router';
import registerVant from './plugins/vant';

registerVant();

Vue.config.productionTip = false;

const DEFAULT_TITLE = '新闻所历史';
router.afterEach((to) => {
  document.title = to.meta?.title || DEFAULT_TITLE;
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
